export default function initialize() {
    $(document).on('click', '.js-remove-coupon', (e) => {
        $(e.currentTarget).closest('.js-payment-summary').find('.js-coupon-message').addClass('visually-hidden');
        $.ajax({
            url: $(e.currentTarget).attr('data-url'),
            success(html) {
                $(e.currentTarget).closest('.js-payment-summary').html(html);
            },
            error() {
                $(e.currentTarget).closest('.js-payment-summary').find('.js-coupon-remove-error-message').removeClass('visually-hidden');
            },
        });
    });

    $(document).on('click', '.js-add-coupon', (e) => {
        $(e.currentTarget).closest('.js-payment-summary').find('.js-coupon-message').addClass('visually-hidden');
        $.ajax({
            url: `${$(e.currentTarget).attr('data-url')}?couponCode=${$(e.currentTarget).siblings('.js-coupon-code').val()}`,
            success(html) {
                $('.js-payment-summary').html(html);
                $('.js-payment-summary').find('.js-coupon-add-error-message').removeClass('visually-hidden');
            },
            error() {
                $('.js-payment-summary').find('.js-coupon-add-error-message').removeClass('visually-hidden');
            },
        });
    });
    $(document).on('click', '.js-coupon-box-trigger', (e) => {
        $(e.currentTarget).closest('.coupon-box-wrapper').addClass('open');
    });
}
